import React, { useEffect, useState } from "react";
import Modal from "../Modal";
import apiClient from "lib/api-client";
import Table from "./Table";
import { getIcon } from "utils/iconsConfig";
import { IconButton } from "@mui/material";
import SaleTray from "./SaleTray";

const TrendTray = ({ open, handleClose, no, type = "Sets" }) => {
  const [yearlySalesData, setYearlySetData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [view, setView] = useState(true);
  const fetchYearlySales = async () => {
    setLoading(true);
    try {
      const response = await apiClient.get(`/api/v1/styles/trendSalesYearly?styleNumber=${no}&clientCode=false`);
      setYearlySetData(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching sales data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (open) {
      fetchYearlySales();
      setView(true);
    }
  }, [open]);
  const title = view ? "Trend Of" : "Sales Of";
  const secondaryIcon = view ? "usergrp" : "date";
  return (
    <Modal open={open} handleClose={handleClose} style={{ width: view ? "300px" : "350px" }}>
      <div onClick={(e) => e.stopPropagation()}>
        <div style={styles.container}>
          <div style={styles.headerRight}>
            {view ? (
              getIcon("date", "black")
            ) : (
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  setView(!view);
                }}
              >
                {getIcon("usergrp", "black")}
              </IconButton>
            )}
            <p style={styles.titleText}>
              {title} {type === "Sets" ? `SET - ${no}` : no}
            </p>
          </div>
          <IconButton
            onClick={(e) => {
              e.stopPropagation();
              setView(!view);
            }}
          >
            {getIcon(secondaryIcon, "black")}
          </IconButton>
        </div>
        {loading ? <div>Loading...</div> : view ? <Table yearlySalesData={yearlySalesData} /> : <SaleTray open={open} handleClose={handleClose} styleNumber={no} clientCode={false} />}
      </div>
    </Modal>
  );
};
const styles = {
  container: { width: "100%", height: "40px", display: "flex", gap: 10, marginBottom: "10px", alignItems: "center", justifyContent: "space-between" },
  headerRight: {
    display: "flex",
    alignItems: "center",
    gap: 10,
  },
  titleText: { fontFamily: "Poppins", fontWeight: 500, fontSize: "18px", margin: 0, padding: 0, lineHeight: "27px" },
};
export default TrendTray;
